import { Link } from "react-router-dom";
import type { Episode } from "@/types";

interface EpisodeDirectoryProps {
  episodes: Episode[];
  currentId: string;
}

export default function EpisodeDirectory({ episodes, currentId }: EpisodeDirectoryProps) {
  const sorted = [...episodes].sort((a, b) => a.number - b.number);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-base font-semibold text-foreground-900">剧集目录</h2>
        <span className="font-label text-xs text-foreground-400">共 {episodes.length} 集</span>
      </div>
      <ul className="mt-4 flex max-h-[520px] flex-col gap-1.5 overflow-y-auto pr-1">
        {sorted.map((episode) => {
          const active = episode.id === currentId;
          return (
            <li key={episode.id}>
              <Link
                to={`/detail/${episode.id}`}
                className={`flex items-center gap-3 rounded-md px-3 py-2 transition-colors ${
                  active
                    ? "bg-primary-700 text-background-50"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                <span
                  className={`flex h-5 flex-shrink-0 items-center rounded font-label text-[11px] ${
                    active ? "text-background-200" : "text-foreground-400"
                  }`}
                >
                  {String(episode.number).padStart(2, "0")}
                </span>
                <span className="truncate font-label text-sm">{episode.title}</span>
                {active && (
                  <span className="ml-auto flex h-4 w-4 flex-shrink-0 items-center justify-center">
                    <i className="ri-play-fill text-sm leading-none"></i>
                  </span>
                )}
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}